import { SavedAlertsByMedium } from 'modules/campaigns/alerts/types';

/**
 * Returns an array of all project campaign alerts configurations
 */
export const getAllProjectCampaignAlerts = (projectCampaignAlerts: SavedAlertsByMedium) =>
  Object.values(projectCampaignAlerts).reduce((prev, curr) => {
    return [...prev, ...curr];
  }, []);
